module.exports = __webpack_public_path__ + "static/img/4595_phase_function_Paper_Points.ac7944a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4595_phase_function_Paper_Points.png
// module id = 7KFZ
// module chunks = 0